export const ClientsTableColumns = (isArabic) => [
    { id: 'title', label: isArabic ? 'الاسم' : 'Title', align: 'start' },
    { id: 'image', label: isArabic ? 'الشعار' : 'Logo', align: 'center' },
    { id: 'created_at', label: isArabic ? 'تاريخ الإضافة' : 'Created At', align: 'start' }
];